import { resourceReducer, getResources, getStatus } from 'redux-resource';

export default resourceReducer('customPlans');

export const getCustomPlanPricing = (state, id) => getResources(state, [id])[0];
export const getCustomPlanPricingList = (state, page = 1) =>
  getResources(state, `fetchCustomPlanPricingList${page}`);
export const getUserCustomPlans = (state) =>
  getResources(state, `fetchUserCustomPlanPricingList`);
export const getUserCustomPlansStatusPending = (state) =>
  getStatus(state, 'requests.fetchUserCustomPlanPricingList.status').pending;
export const updateCustomPlanPricingStatusPending = (state) =>
  getStatus(state, 'requests.updateCustomPlanPricing.status').pending;
export const createCustomPlanPricingStatusPending = (state) =>
  getStatus(state, 'requests.createCustomPlanPricing.status').pending;
export const deleteCustomPlanPricingStatusPending = (state) =>
  getStatus(state, 'requests.deleteCustomPlanPricing.status').pending;
